import { Injectable } from "@angular/core";
import { EDepositServiceCode } from "@common/models";
import { HttpRequestPayload, IHttpSuccessPayload } from "@core/models";
import { HttpProviderService, HttpRequest } from "@fpx/core";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { IContextualMenu } from "src/app/common/models/contextual-menu.model";
import { DepositDetail } from "src/app/models/Deposit-details.model";
import { DepositInfo } from "src/app/models/Deposit.model";
import { ITermDepositDetails } from "src/app/models/account-info.model";
import { ProcessShellService } from "src/app/process-shell/services/process-shell.service";
import { ProvidehttpService } from "src/app/providehttp.service";
import { CustomerService } from "src/app/services/customer.service";
import { environment } from "src/environments/environment.prod";
import { AccountsService } from "src/app/services/accounts/accounts.service";
import { ADDITIONAL_DETAILS } from "@common/constants";

@Injectable({
  providedIn: "root",
})
export class DepositService {
  private _depositsInfo: Map<string, DepositInfo> = new Map<
    string,
    DepositInfo
  >();

  selectedDepositAccount: DepositInfo;

  contextualMenuList: IContextualMenu[] = [
    
    {

      id: "D008",
      icon: "deposit-open-new-deposit",
      name: "Open New <em>Deposit</em>",
      title: "Open New Deposit",
      path: ["process-shell", "deposits", "deposit-request-form"],
     desktopPath: ["home", "transactions","process-shell", "deposits", "deposit-request-form"],
      serviceCode: "OPENEWDEPOSIT",
      processCode: "OPENEWDEPOSIT",
      queryParams:{
        serviceCode:"OPENEWDEPOSIT",
      }
    },{

      id: "D003",
      icon: "deposit-change-maturity-instruction",
      name: "Change Maturity <em>Instruction</em>",
      title: "Maturity Instruction",
      path: ["process-shell", "deposits", "change-maturity-instruction"],
      desktopPath: ["home", "transactions","process-shell", "deposits", "change-maturity-instruction"],
      serviceCode:"CHNGMATURITYINSTR" ,
      processCode: "CHNGMATURITYINSTR",
      queryParams:{
        serviceCode:"CHNGMATURITYINSTR",
      }
    }
  ];

  constructor(
    private httpService: ProvidehttpService,
    private _customerService: CustomerService,
    private _httpProvider: HttpProviderService,
    private _accountService: AccountsService,
    private _processShellService: ProcessShellService
  ) {}

  getMenuList(): IContextualMenu[] {
    return this.contextualMenuList;
  }
  getDepositsList(): DepositDetail[] {
    if (
      this._customerService.customerInfo.accountInfo.termDeposits.product[0]
        ?.accountDetails
    ) {
      this._customerService.customerInfo.accountInfo.termDeposits.product[0]?.accountDetails?.map(
        (account) => {
          let _a = this._accountService.nicknames?.find(
            (x) => x.accountNumber == account.accountNumber
          );
          return (account["nickName"] = _a?.nickName || "");
        }
      );
    }
    return this._customerService.customerInfo.accountInfo.termDeposits
      .product[0]?.accountDetails;
  }

  getSelectedMenuData(menuId: string) {
    const selectedMenuItem = this.contextualMenuList.find(
      (item) => item.id == menuId
    );
    return selectedMenuItem;
  }

  /**
   *
   * @param accountNumber
   * @returns depositInfo
   */
  getInfo(accountNumber: string): DepositDetail {
    const depositAccount = this.getList().find(
      (item) => item.accountNumber === accountNumber
    );
    return depositAccount;
  }
  fetchDepositInfo(accountNumber: string): Observable<any> {
    if (!accountNumber) {
      return of(null);
    }
    if (this._depositsInfo.has(accountNumber)) {
      return of(this._depositsInfo.get(accountNumber));
    } else {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod("GET");
      httpRequest.setResource("/deposits/{accountNumber}");
      httpRequest.addPathParameter("accountNumber", accountNumber);
      let bodyContent = {};
      httpRequest.setBody(bodyContent);
      httpRequest.setServerContext(environment.depositsPublisher);

      return this._httpProvider.invokeRestApi(httpRequest).pipe(
        map((res: any) => {
          let result: DepositDetail = res.body?.deposits;
          // this._depositsInfo.set(accountNumber, result);
          return result;
        })
      );
    }
  }

  getOverview(): ITermDepositDetails {
    return this._customerService.getDeposits();
  }

  getList(): DepositDetail[] {
    let products = this._customerService.getDeposits().product;

    let list = [];
    products.forEach((product) => {
      list = list.concat(product.accountDetails);
    });

    return list;
  }

  /**
   *
   * @param depositAccountNumber
   * @returns
   */
  getDepositDetails(depositAccountNumber: string): DepositDetail {
    let depositDetails: DepositDetail = this._customerService
      .getDepositDetails()
      .find((item) => item.accountNumber == depositAccountNumber);
    return depositDetails;
  }

  getDepositInfo(depositAccountNumber: string): Observable<DepositInfo> {
    if (this._depositsInfo.has(depositAccountNumber)) {
      return of(this._depositsInfo.get(depositAccountNumber));
    } else {
      return this.fetchDepositInfo(depositAccountNumber).pipe(
        map((res) => {
          return this._depositsInfo.get(depositAccountNumber);
        })
      );
    }
  }
  triggerFormSubmitCopleted(result: any) {
    this._processShellService.processId = result?.processId;
    this._processShellService.triggerFormSubmittedCompleteStatus(result);
  }
}
